import cx from 'classnames';

import styles from './BetaLabel.module.scss';

interface BetaLabelProps {
  className?: string;
}

export const BetaLabel = ({ className }: BetaLabelProps) => (
  <span className={cx(styles.root, className)}>Beta</span>
);
